import React, { useEffect } from "react";
import "./Navbar.css";
import { HomeIcon, MessageIcon, ProfileIcon } from "../icons";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser, selectAuth } from "../../features/auth/authSlice";
import { UserMenu, SignInMenu, SignUpMenu } from "../Menus";
import Logo from "../../images/logo.png";
import {
  ChangePasswordModal,
  ContactInfoModal,
  ForgotPassModal,
  PaymentInfoModal,
  TxReceiptModal,
} from "../Modals";
import UserMenuModals from "../Modals/UserMenuModals";
import Button from "../Button";
import CategoryList from "../CategoryList";
import { useGetCategoriesQuery } from "../../features/supabase/usecase/categories";
import CategorySkeleton from "../Skeleton/CategorySkeleton";

const Navbar = () => {
  const [popupMenuOpen, setPopupMenuOpen] = React.useState(false);
  const [showMenu, setShowMenu] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [isSignInMenu, setIsSignInMenu] = React.useState(true);
  const [showForgotModal, setShowForgotModal] = React.useState(false);
  const { data: categories, error, isLoading } = useGetCategoriesQuery();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pathname = useLocation().pathname;
  const onModalClose = () => {
    setOpenModal("");
  };
  const user = useSelector(selectAuth);

  useEffect(() => {
    dispatch(getCurrentUser());
  }, []);

  return (
    <>
      <div className="navbar-container">
        <div className="navbar-action-buttons">
          <NavLink to="/" className="home-button">
            <HomeIcon height={30} width={30} fill={"white"} />
            COLlive Market
          </NavLink>
        </div>
        <a href="https://collive.com/" style={{
          zIndex: 10,
        }}>
          <img src={Logo} className="navbar-logo" />
        </a>
        {user.user ? (
          <div className="navbar-action-buttons">
            <div style={{ position: "relative" }} className={"profile-btn"}>
              <ProfileIcon
                size={35}
                stroke={"white"}
                className="navbar-action-button profile"
                onClick={() => setShowMenu((val) => !val)}
              />
              {showMenu && (
                <UserMenu
                  isOpen={showMenu}
                  setIsOpen={setShowMenu}
                  openModal={openModal}
                  setOpenModal={setOpenModal}
                />
              )}
              <UserMenuModals modal={openModal} onClose={onModalClose} />
            </div>
          </div>
        ) : (
          <>
            <div className="profile-auth-btn">
              <ProfileIcon
                size={35}
                stroke={"#949198"}
                fill={"#fff"}
                className="navbar-action-button"
                id="profile-icon"
                onClick={() => setPopupMenuOpen((val) => !val)}
              />
              {popupMenuOpen &&
                (isSignInMenu ? (
                  <SignInMenu
                    setIsSignIn={setIsSignInMenu}
                    isOpen={popupMenuOpen}
                    onSignUpClick={() => {
                      setIsSignInMenu(false);
                      setPopupMenuOpen(true);
                    }}
                    setIsOpen={setPopupMenuOpen}
                    showForgotModal={showForgotModal}
                    setShowForgotModal={setShowForgotModal}
                    closeModal={() => {
                      setIsSignInMenu(true);
                      setPopupMenuOpen(false);
                    }}
                  />
                ) : (
                  <SignUpMenu
                    onSignInClick={() => {
                      setIsSignInMenu(true);
                      setPopupMenuOpen(true);
                    }}
                    isOpen={popupMenuOpen}
                    setIsOpen={setPopupMenuOpen}
                    closeModal={() => {
                      setIsSignInMenu(true);
                      setPopupMenuOpen(false);
                    }}
                  />
                ))}
              {showForgotModal && (
                <ForgotPassModal
                  isOpen={showForgotModal}
                  setIsOpen={setShowForgotModal}
                  goToSignIn={() => {
                    setShowForgotModal(false);
                    setPopupMenuOpen(true);
                  }}
                />
              )}
            </div>
          </>
        )}
      </div>
      {pathname !== '/submit' && <section className="category" title="Category" style={{ marginTop: "90px" }}>
        {isLoading ? (
          <div className="category-list">
            {Array(10)
              .fill(0)
              .map((_, i) => (
                <CategorySkeleton key={i} />
              ))}
          </div>
        ) : (
          <CategoryList categories={categories} />
        )}
      </section>}
    </>
  );
};

export default Navbar;
